module.exports = __webpack_public_path__ + "media/images/user_1_default_avatar-b111b4912a9d0fa710079530c9c39831.png";